import React, { useEffect, useState } from 'react';
import { useKingsomniUser } from '../hooks/useKingsomniUser';
import { usePrivy } from '@privy-io/react-auth';

interface AuthComponentProps {
  onUserChange?: (user: any) => void;
}

export function AuthComponent({ onUserChange }: AuthComponentProps) {
  const [isClient, setIsClient] = useState(false);
  const { login, logout, authenticated } = usePrivy();
  const kingsomniUser = useKingsomniUser();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (onUserChange && isClient && !kingsomniUser.isLoading) {
      if (authenticated && kingsomniUser.address) {
        onUserChange(kingsomniUser);
      } else if (!authenticated) {
        onUserChange(null);
      }
    }
  }, [isClient, authenticated, kingsomniUser, onUserChange]);

  if (!isClient || kingsomniUser.isLoading) {
    return (
      <div className="auth-component">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="auth-component">
        <button onClick={() => login()} className="login-btn">
          Sign in with Privy
        </button>
      </div>
    );
  }

  return (
    <div className="auth-component">
      <div className="user-info">
        <div className="welcome">
          Connected: {kingsomniUser.address?.slice(0, 6)}...{kingsomniUser.address?.slice(-4)}
        </div>
        <button onClick={() => logout()} className="logout-btn">
          Logout
        </button>
      </div>
    </div>
  );
}
